/**
 * hostSeniority — formats the "X anni/mesi da host" pill (Airbnb-style).
 * Rules:
 *   • < 1 month  → "Nuovo su Hostland"
 *   • 1-11 months → "N mesi da host" (singular for 1)
 *   • >= 12 months → "N anni da host" (singular for 1). Fractional years rounded DOWN.
 * Uses the app's translation dict; falls back to Italian if a key is missing.
 */

export function formatHostSeniority(createdAtIso, t) {
  if (!createdAtIso) return null;
  const created = new Date(createdAtIso);
  if (Number.isNaN(created.getTime())) return null;
  const now = new Date();
  const ms = now - created;
  if (ms <= 0) return t ? t("host.new") : "Nuovo su Hostland";

  const totalDays = Math.floor(ms / (1000 * 60 * 60 * 24));
  const months = Math.floor(totalDays / 30.4375); // avg month length
  const years = Math.floor(totalDays / 365.25);

  const fill = (key, n) => {
    if (!t) return key.replace("{n}", n);
    const s = t(key);
    return s.replace("{n}", n);
  };

  if (years >= 1) {
    return years === 1 ? (t ? t("host.years_one") : "1 anno da host") : fill("host.years_many", years);
  }
  if (months >= 1) {
    return months === 1 ? (t ? t("host.months_one") : "1 mese da host") : fill("host.months_many", months);
  }
  return t ? t("host.new") : "Nuovo su Hostland";
}
